import { ChangeDetectionStrategy, Component, booleanAttribute, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

/**
 * Translucent overlay with a centered spinner. `fullPage` makes it cover
 * the viewport; otherwise it fills its nearest positioned ancestor.
 */
@Component({
  selector: 'vh-loading-overlay',
  standalone: true,
  imports: [MatProgressSpinnerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (visible()) {
      <div class="vh-overlay" [class.vh-overlay--full]="fullPage()">
        <mat-progress-spinner mode="indeterminate" diameter="40" />
      </div>
    }
  `,
  styleUrl: './loading-overlay.component.scss',
})
export class VhLoadingOverlayComponent {
  readonly visible = input(false, { transform: booleanAttribute });
  readonly fullPage = input(false, { transform: booleanAttribute });
}
